export const autoCompleteConfig = {
  street_number: 'street_number',
  street: 'route',
  city: 'locality',
  neighborhood: 'neighborhood',
  state: 'administrative_area_level_1',
  zip: 'postal_code'
};



// WEBPACK FOOTER //
// ./src/constants/addressAutoComplete.js